import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "item"]

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)

    // Focus on search input when dropdown opens
    this.element.addEventListener('shown.bs.dropdown', () => {
      if (this.hasSearchTarget) {
        this.searchTarget.focus()
      }
      // Add global keydown listener when dropdown is open
      document.addEventListener('keydown', this.handleKeydown)
    })

    // Remove global keydown listener when dropdown closes
    this.element.addEventListener('hidden.bs.dropdown', () => {
      document.removeEventListener('keydown', this.handleKeydown)
    })
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleKeydown)
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      // Find the dropdown toggle and close it
      const dropdownToggle = this.element.querySelector('[data-bs-toggle="dropdown"]')
      if (dropdownToggle) {
        const dropdown = bootstrap.Dropdown.getInstance(dropdownToggle)
        if (dropdown) {
          // Stop propagation to prevent closing parent offcanvas/modal
          event.stopPropagation()
          event.preventDefault()
          dropdown.hide()
        }
      }
    }
  }

  filter(event) {
    const searchTerm = event.target.value.toLowerCase()
    const items = this.element.querySelectorAll('[data-searchable]')

    items.forEach(item => {
      const searchableText = item.getAttribute('data-searchable') || ''
      if (searchableText.toLowerCase().includes(searchTerm)) {
        item.style.display = ''
      } else {
        item.style.display = 'none'
      }
    })
  }

  preventClose(event) {
    event.stopPropagation()
  }
}